'use strict';

const saContactButton = function () {
  return {
    restrict: 'A',
    controller: [
      '$element',
      'contact',

      function ($element, contact) {
        $element.on('click', contact.showModal);

        $element.on('$destroy', function () {
          $element.off('click', contact.showModal);
        });
      }
    ]
  };
};

export default saContactButton;



// WEBPACK FOOTER //
// ./app/src/directives/contact_button.js